const salesLang = {
  menuTitle: 'Ventes',
  params: {
    menu: 'Paramètres',
    pageTitle: 'Configuration des ventes',

    referenceTitle: 'Numérotation des documents',
    referencePrefix: 'Préfixe',
    referenceNextNumber: 'Prochain numéro',
    referenceTypeNumber: 'Type de numérotation',
    referenceLength: 'Nombre de chiffre',
    referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
    referenceYear4: 'l\'année sur 4 chiffres',
    referenceYear2: 'l\'année sur 2 chiffres',
    referenceMonth: 'le mois',
    referenceDay: 'le jour',

    depositTitle: 'Facturation des acomptes',
  },
  exports: {
    typeLabel: 'Type d\'export',
    typeDatas: 'Données des documents',
    typePdf: 'Fichiers PDF',
    contentDatas: 'Exporter le contenu des documents',
    allDatas: 'Exporter toutes les informations disponibles (En-têtes + contenu)'
  },
  unit: {
    menu: 'Unités',
    pageTitle: 'Gestion des unités',
    label: 'Nom de l\'unité',
    new: 'Création d\'une unité',
    edit: 'Modification d\'une unité',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette unité ?'
  },
  saleTerm: {
    menu: 'CGV',
    pageTitle: 'Gestion des conditions de vente',
    label: 'Nom des conditions de vente',
    contentLabel: 'Contenu des conditions de vente',
    new: 'Création de conditions de vente',
    edit: 'Modification des conditions de vente',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ces conditions de vente ?'
  },
  account: {
    menu: 'Comptes bancaires',
    pageTitle: 'Gestion des comptes bancaires',
    label: 'Nom du compte',
    new: 'Création d\'un compte bancaire',
    edit: 'Modification d\'un compte bancaire',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce compte bancaire ?',
    form: {
      name: 'Nom du compte bancaire',
      useDefault: 'Utiliser ce compte par défaut',
      coordinates: 'Coordonnées bancaires et prélèvements SEPA',
      owner: 'Titulaire du compte bancaire',
      iban: 'IBAN',
      bic: 'BIC',
      sepaId: 'Identifiant SEPA',
      check: 'Remises de chèque',
      checkExplain: 'Ces données sont utilisées pour générer vos remises de chèque PDF.',
      accountNumber: 'Numéro de compte',
      accountCode: 'Code banque / indicatif',
      fecPart: 'Exports comptable - Fichier FEC',
      fecCode: 'Numéro du compte',
      fecExplain: 'Utiliser pour la génération des journaux comptable et du fichier FEC.'
    },
    elementTypes: {
      invoice: 'Facture',
      credit: 'Avoir',
      charge: 'Charge'
    }
  },
  customerSepa: {
    reference: 'Mandat SEPA n°{reference}',
    type: 'Type',
    type1: 'Récurrent',
    type2: 'Ponctuel',
    sepaType: 'Type de mandat SEPA',
    sepaType1: 'CORE',
    sepaType2: 'B2B',
    address: 'Adresse du client',
    customer: 'Client',
    new: 'Création d\'un mandat SEPA',
    edit: 'Modification d\'un mandat SEPA',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mandat SEPA ?',
    name: 'Nom du mandat SEPA',
    owner: 'Titulaire du compte bancaire',
    iban: 'IBAN',
    bic: 'BIC',
    sepaIdent: 'Numéro de mandat SEPA',
    date: 'Date de signature',
    status: 'Statut',
    status1: 'Brouillon',
    status2: 'En cours',
    status3: 'Terminé'
  },
  sepaDeposit: {
    invoiceSearchResult: 'Aucune facture ne correspond à la recherche | {count} facture correspond à la recherche | {count} factures correspondent à la recherche',
    totalInvoice: '{count} facture | {count} factures'
  },
  checkDeposit: {
    paymentSearchResult: 'Aucun paiement ne correspond à la recherche | {count} paiement correspond à la recherche | {count} paiements correspondent à la recherche',
    totalPayment: '{count} paiement | {count} paiements'
  },
  paymentMethod: {
    menu: 'Moyens de paiement',
    pageTitle: 'Gestion des moyens de paiement',
    label: 'Nom du moyen de paiement',
    typeLabel: 'Type de moyen de paiement',
    typeComments: 'Il est nécessaire d\'indiquer le type de moyen de paiement au logiciel afin que les fonctionnalités liées aux moyens de paiement fonctionnent correctement.',
    new: 'Création d\'un moyen de paiement',
    edit: 'Modification d\'un moyen de paiement',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce moyen de paiement ?',
    types: {
      card: 'Carte bancaire',
      check: 'Chèque',
      cash: 'Espèce',
      directDebit: 'Prélèvement',
      directTransfert: 'Virement',
      other: 'Autre'
    },
    replacementComments: 'Ce moyen de paiement est utilisé, il doit donc être fusionné avec un autre moyen de paiement afin que le logiciel fonctionne normalement.'
  },
  vatRate: {
    menu: 'Taux de TVA',
    pageTitle: 'Gestion des taux de TVA',
    rateLabel: 'Taux de TVA',
    label: 'Label',
    commentsLabel: 'Le label vous permet d\'identifier un taux de TVA lorsque vous avez plusieurs taux de TVA identiques.',
    mentionLabel: 'Mention à afficher sur les documents PDF',
    new: 'Création d\'un taux de TVA',
    edit: 'Modification d\'un taux de TVA',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce taux de TVA ?',
    replacementComments: 'Ce taux de TVA est utilisé, vous ne pouvez donc pas le supprimer. Cependant, il est possible de le fusionner avec un taux de TVA indentique.'
  },
  saleCategory: {
    menu: 'Catégories de vente',
    pageTitle: 'Gestion des catégories de vente',
    label: 'Nom de la catégorie',
    parentLabel: 'Catégorie parente',
    accountLabel: 'Compte comptable',
    new: 'Création d\'une catégorie de vente',
    edit: 'Modification d\'une catégorie de vente',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de vente ?',
    accountByVatRate: 'Comptes '
  },
  pdfModel: {
    menu: 'Modèles PDF',
    pageTitle: 'Gestion des modèles PDF',
    label: 'Nom du modèle PDF',
    addTitle: 'Création d\'un modèle PDF',
    addLabel: 'Créer un modèle PDF',
    new: 'Création d\'un modèle PDF',
    edit: 'Modification d\'une catégorie de vente',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce modèle PDF ?'
  },
  paymentTerm: {
    menu: 'Conditions de paiement',
    pageTitle: 'Gestion des conditions de paiement',
    new: 'Création d\'une condition de paiement',
    edit: 'Modification d\'une condition de paiement',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette condition de paiement ?',
    label: 'Nom de la condition de paiement',
    nbDays: 'Nombre de jour',
    endMonth: 'Fin de mois',
    endMonthDay: 'Fin de mois le'
  },
  grant: {
    menu: 'Subventions',
    pageTitle: 'Liste des subventions',
    new: 'Création d\'une subvention',
    edit: 'Modification d\'une subvention',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette subvention ?',
    label: 'Désignation',
    pdfMentions: 'Affichage sur le PDF',
    pdfMentionsExplain: 'Ce texte sera affiché sur le document PDF dans le tableau des totaux en face du montant de la subvention.',
    type: 'Type de subvention',
    typePourcent: 'Pourcentage',
    typeAmount: 'Montant',
    pourcent: 'Pourcentage à appliquer au total TTC'
  },
  affair: {
    menu: 'Affaires',
    label: 'Affaire',
    reference: 'Affaire n°{reference}'
  },
  quotation: {
    menu: 'Devis',
    label: 'Devis',
    reference: 'Devis n°{reference}',
    newTitle: 'Création d\'un devis',
    editTitle: 'Modification du devis n°{reference}',
    cantEdited: 'Un devis facturé à 100% ne peut pas être modifié',
    cantEditedWithSituation: 'Un devis avec une facture d\'avancement ne peut pas être modifié'
  },
  command: {
    menu: 'Bons de commande',
    label: 'Bon de commande',
    reference: 'Bon de commande n°{reference}',
    newTitle: 'Création d\'un bon de commande',
    editTitle: 'Modification du bon de commande n°{reference}',
    cantEdited: 'Un bon de commande facturé à 100% ne peut pas être modifié',
    cantEditedWithSituation: 'Un bon de commande avec une facture d\'avancement ne peut pas être modifié',
  },
  depositInvoice: {
    menu: 'Factures d\'acompte',
    label: 'Facture d\'acompte',
    reference: 'Facture d\'acompte n°{reference}',
    newTitle: 'Création d\'une facture d\'acompte',
    editTitle: 'Modification de la facture d\'acompte n°{reference}',
    cantEdited: 'Une facture qui n\'est plus au statut brouillon ne peut pas être modifiée'
  },
  situationInvoice: {
    label: 'Factures de situation',
    reference: 'Facture de situation n°{reference}',
  },
  proforma: {
    menu: 'Factures proforma',
    label: 'Facture proforma',
    reference: 'Facture proforma n°{reference}',
    newTitle: 'Création d\'une facture proforma',
    editTitle: 'Modification de la facture proforma n°{reference}',
    cantEdited: 'Une facture proforma facturée à 100% ne peut pas être modifiée'
  },
  delivery: {
    menu: 'Bons de livraison',
    label: 'Bon de livraison',
    reference: 'Bon de livraison n°{reference}',
    newTitle: 'Création d\'un bon de livraison',
    editTitle: 'Modification du bon de livraison n°{reference}',
    cantEdited: 'Un bon de livraison facturé ne peut pas être modifié'
  },
  invoice: {
    menu: 'Factures',
    label: 'Facture',
    reference: 'Facture n°{reference}',
    newTitle: 'Création d\'une facture',
    editTitle: 'Modification de la facture n°{reference}',
    cantEdited: 'Une facture qui n\'est plus au statut brouillon ne peut pas être modifiée'
  },
  credit: {
    menu: 'Avoirs',
    label: 'Avoir',
    reference: 'Avoir n°{reference}',
    newTitle: 'Création d\'un avoir',
    editTitle: 'Modification de l\'avoir n°{reference}',
    cantEdited: 'Un avoir qui n\'est plus au statut brouillon ne peut pas être modifié'
  },
  provider_command: {
    label: 'Bon de commande'
  },
  contract: {
    reference: 'Contrat n°{reference}',
    label: 'Contrat'
  },
  opportunity: {
    label: 'Opportunité'
  },
  construction: {
    label: 'Chantier'
  },
  form: {
    newPageTitle: {
      quotation: 'Création d\'un devis',
      command: 'Création d\'un bon de commande',
      delivery: 'Création d\'un bon de livraison',
      proforma: 'Création d\'une facture proforma',
      invoice: 'Création d\'une facture',
      credit: 'Création d\'un avoir'
    },
    editPageTitle: {
      quotation: 'Modification d\'un devis',
      command: 'Modification d\'un bon de commande',
      delivery: 'Modification d\'un bon de livraison',
      proforma: 'Modification d\'une facture proforma',
      invoice: 'Modification d\'une facture',
      credit: 'Modification d\'un avoir'
    },
    titleCustomer: 'Informations client',
    titleDocument: {
      quotation: 'Informations du devis',
      command: 'Informations du bon de commande',
      delivery: 'Informations du bon de livraison',
      proforma: 'Informations de la facture proforma',
      invoice: 'Informations de la facture',
      credit: 'Informations de l\'avoir'
    },
    customer: 'Client',
    contact: 'Contact',
    invoiceAddress: 'Adresse de facturation',
    deliveryAddress: 'Adresse de livraison',
    constructionAddress: 'Adresse de chantier',
    customCustomerName: 'Personnaliser le nom du client',
    customContactName: 'Personnaliser le nom du contact',
    withRoad3: 'Ajouter une troisième ligne à l\'adresse',
    withComments: 'Ajouter des commentaires',
    customVatrateNumber: 'Personnaliser le n° de TVA intracommunautaire',
    road: 'Rue',
    road3: 'Rue 3',
    vatrateNumber: 'N° TVA intracommunautaire',
    vartrateNumberShort: 'N° TVA intra.',
    comments: 'Commentaires',
    title: {
      quotation: 'Titre du devis',
      command: 'Titre du bon de commande',
      delivery: 'Titre du bon de livraison',
      proforma: 'Titre de la facture proforma',
      invoice: 'Titre de la facture',
      credit: 'Titre de l\'avoir'
    },
    date: {
      quotation: 'Date du devis',
      command: 'Date du bon de commande',
      delivery: 'Date du bon de livraison',
      proforma: 'Date de la facture proforma',
      invoice: 'Date de la facture',
      credit: 'Date de l\'avoir'
    },
    expirationDate: 'Limite de validité',
    paymentDate: 'Limite de paiement',
    reference: {
      generic: 'N° du document',
      quotation: 'N° du devis',
      command: 'N° du bon de commande',
      delivery: 'N° du bon de livraison',
      proforma: 'N° de la facture proforma',
      invoice: 'N° de la facture',
      credit: 'N° de l\'avoir'
    },
    paymentTerm: 'Conditions de règlement',
    commandReference: 'Bon de commande client',
    addCommandReference: 'Renseigner le numéro de bon de commande fourni par votre client',
    advancePayment: 'Acompte',
    vatRate: 'Taux de TVA',
    quantity2: 'Quantité 2',
    unit: 'Unité',
    tags: 'Mots-clés',
    pdfModel: 'Modèle PDF',
    commercial: 'Commercial',
    customerNotes: 'Notes à l\'attention du client',
    addCustomerNotes: 'Ajouter des notes à l\'attention du client',
    titleContent: 'Contenu du document',
    emptyLine: 'Ligne vide',
    commentsLine: 'Commentaires',
    subtotalLine: 'Sous-total',
    pagebreakLine: 'Saut de page',
    columns: {
      number: 'N°',
      reference: 'Référence',
      unitPriceHt: 'Prix U. HT',
      unitPriceTtc: 'Prix U. TTC',
      vatRate: 'Taux TVA',
      quantity2: 'Quantité 2',
      totalHt: 'Total HT',
      totalTtc: 'Total TTC'

    },
    noContent: 'Le document ne contient aucune ligne',
    totals: {
      globalDiscount: 'Remise générale',
      globalDiscountHt: 'HT',
      globalDiscountTtc: 'TTC',
      totalHt: 'Total HT :',
      tva: 'TVA :',
      tvaRate: 'TVA {rate} % :',
      totalTtc: 'Total TTC :'
    },
    lines: {
      pageBreak: 'Saut de page',
      buyPrice: 'Prix d\'achat :',
      variousCosts: 'Coûts divers :',
      totalBuy: 'Total achat :',
      totalCharge: 'Total charge :',
      marginAmount: 'Marge HT :',
      marginRate: 'Taux marge :',
      markupRate: 'Taux marque :',
      duration: 'Durée :',
      durationMinute: 'Mn',
      durationHour: 'H',
      technicalNumber: 'Nb technicien :',
      hourlyCosts: 'Coûts horaire :',
      workoutCosts: 'Main d\'oeuvre :',
      eanCode: 'Code EAN :',
      weight: 'Poids :',
      ecoPart: 'Dont éco-part. :',
      ht: 'ht',
      ttc: 'ttc',
      option: 'Option'
    },
    saveConflict: {
      mostRecentVersion: 'Une version plus récente du document en cours de modification existe.',
      actionsChoice: 'Quelle action souhaitez-vous effectuer ?',
      newWindow: 'Ouvrir la dernière version dans une nouvelle fenêtre',
      forceSave: 'Forcer l\'enregistrement',
      allDatasLost: 'Toutes les données de la version plus récente seront perdues.',
      goNewVersion: 'Rediriger vers la nouvelle version',
      datasNotSaved: 'Les modifications que vous souhaitez apportées ne seront pas enregistrées et seront donc perdues.'
    },
    sidebar: {
      inputOptions: 'Options de saisie',
      pdfCustomization: 'Personnalisation du PDF',
      sidebarPosition: 'Modifier la position de la barre',
      fullscreen: 'Plein écran',
      totalHt: 'Total HT',
      totalTva: 'Total TVA',
      totalTtc: 'Total TTC',
      workout: 'Main d\'oeuvre',
      costs: 'Coûts',
      marginAmount: 'Marge Brute HT',
      marginRate: 'Taux de marge',
      markupRate: 'Taux de marque',
      saveContinue: 'Enregistrer',
      createDraft: 'Créer en brouillon',
      createValid: 'Créer et valider',
      editDraft: 'Modifier',
      editValid: 'Modifier et valider',
      action: {
        quotation: {
          create: 'Créer le devis',
          edit: 'Modifier le devis'
        },
        command: {
          create: 'Créer le bon de commande',
          edit: 'Modifier le bon de commande'
        },
        delivery: {
          create: 'Créer le bon de livraison',
          edit: 'Modifier le bon de livraison'
        },
        proforma: {
          create: 'Créer la proforma',
          edit: 'Modifier la proforma'
        },
        invoice: {
          create: 'Créer la facture',
          edit: 'Modifier la facture'
        },
        credit: {
          create: 'Créer l\'avoir',
          edit: 'Modifier l\'avoir'
        }
      }
    },
    saveDefaultBtn: 'Enregistrer comme configuration par défaut',
    saveDefaultConfirmation: 'Êtes-vous sûr de vouloir enregistrer ces informations comme configuration par défaut pour vos prochains documents ?',
    inputOptions: {
      explain: 'Gérez les différentes options qu\'il vous est possible de saisir lors de la rédaction de votre document.',
      deliveryAddress: 'Adresse de livraison / de chantier',
      activeDeliveryAddress: 'Activer la saisie de l\'adresse de livraison',
      vatrateSelection: 'Sélection du taux de TVA',
      vatrateSelectionOne: 'Un seul taux de TVA pour tout le document',
      vatrateSelectionMultiple: 'Un taux de TVA pour chaque ligne du document',
      amountTypes: 'Mode de saisie des montants',
      amountTypesHt: 'Saisie des montants HT',
      amountTypesTtc: 'Saisie des montants TTC',
      allowOptions: 'Possibilité de proposer des options',
      allowOptionsExplain: 'Seul le prix unitaire sera affiché sur le PDF avec le terme \'option\' dans la colonne quantité',
      allowOptionOn: 'Activé',
      disallowOptionOn: 'Désactivé',
      ean: 'Code EAN',
      eanChoice1: 'Aucune saisie, le code EAN sera quand même récupéré sur la fiche produit',
      eanChoice2: 'Saisie uniquement pour les lignes vides',
      eanChoice3: 'Saisie uniquement pour les lignes avec produit',
      eanChoice4: 'Saisie pour les lignes vides et les lignes avec produit',
      eanChoice5: 'Saisie pour toutes les lignes',
      weight: 'Poids',
      weightChoice1: 'Aucune saisie, le poids sera quand même récupéré sur la fiche produit',
      weightChoice2: 'Saisie uniquement pour les lignes vides',
      weightChoice3: 'Saisie uniquement pour les lignes avec produit',
      weightChoice4: 'Saisie pour les lignes vides et les lignes avec produit',
      weightChoice5: 'Saisie pour toutes les lignes',
      ecoParticipation: 'Éco-participation',
      ecoParticipationChoice1: 'Aucune saisie, l\'éco-participation sera quand même indiquée pour les produits concernés',
      ecoParticipationChoice2: 'Saisie uniquement pour les lignes vides',
      ecoParticipationChoice3: 'Saisie uniquement pour les lignes avec produit',
      ecoParticipationChoice4: 'Saisie pour les lignes vides et les lignes avec produit',
      ecoParticipationChoice5: 'Saisie pour toutes les lignes',
      columnTitle: 'Affichage des colonnes',
      columnNumber: 'Afficher la colonne n° de ligne (1,2,3...)',
      columnReference: 'Afficher la colonne référence',
      columnPicture: 'Afficher la colonne photo',
      columnUnit: 'Afficher les unités',
      stockTitle: 'Gestion du stock',
      stockQuantity: 'Affichage du niveau de stock',
      stockQuantityChoice1: 'Afficher le stock théorique',
      stockQuantityChoice2: 'Afficher le stock réel',
      stockQuantityChoice3: 'Afficher le stock théorique et le stock réel',
      stockTracabilities: 'Gestion de stock avec gestion de la traçabilité',
      stockTracabilitiesActive: 'Permettre de sélectionner un produit dans le stock',
      stockTracabilitiesDisable: 'Désactivé',
      stockTracabilitiesExplain1: 'Cette fonctionnalité est obligatoirement activée pour les bons de livraison.',
      stockTracabilitiesExplain2: 'Lorsqu\'un produit est sélectionné et que le document est enregistré, le produit sera immédiatement déduit du stock théorique. Pour les devis, bons de commande et factures proforma, le stock sera recrédité à la date d\'expiration du document si celui-ci n\'a pas été facturé.',
      costsTitle: 'Calcul des coûts',
      costs: 'Saisie des coûts',
      costsChoice1: 'Aucune saisie, les données seront quand même récupérées sur les éléments du catalogue',
      costsChoice2: 'Saisie uniquement pour les lignes vides',
      costsChoice3: 'Saisie uniquement pour les lignes avec produit',
      costsChoice4: 'Saisie uniquement pour les lignes avec éléments du catalogue',
      costsChoice5: 'Saisie pour les lignes vides et les lignes avec produit',
      costsChoice6: 'Saisie pour toutes les lignes',
      variousCosts: 'Activer la saisie des coûts divers',
      workforce: 'Saisie de la main d\'oeuvre',
      workforceChoice1: 'Aucune saisie, les données seront quand même récupérées sur la fiche prestation',
      workforceChoice2: 'Saisie uniquement pour les lignes vides',
      workforceChoice3: 'Saisie uniquement pour les lignes avec prestation',
      workforceChoice4: 'Saisie uniquement pour les lignes avec éléments du catalogue',
      workforceChoice5: 'Saisie pour les lignes vides et les lignes avec prestation',
      workforceChoice6: 'Saisie pour toutes les lignes',
      marginCalculation: 'Calcul de la marge',
      showMarginAmount: 'Afficher la marge brute HT',
      showMarginRate: 'Afficher le taux de marge',
      showMarkupRate: 'Afficher le taux de marque',
      secondaryQuantityTitle: 'Quantité secondaire',
      secondaryQuantityExplain: 'Les quantités secondaires vous permettent de saisir une deuxième quantité qui sera complémentaire de la première. Elles sont généralements utilisées pour facturer des durées.',
      secondaryQuantity: 'Mode de saisie de la quantité secondaire',
      secondaryQuantityChoice1: 'Ne pas utiliser de quantité secondaire',
      secondaryQuantityChoice2: 'Une seule quantité pour tout le document',
      secondaryQuantityChoice3: 'Une quantité secondaire pour chaque ligne du document',
      secondaryQuantityUnit: 'Gestion des unités pour les quantités secondaires',
      secondaryQuantityEnable: 'Activé',
      secondaryQuantityDisabled: 'Désactivé'
    },
    pdfOptions: {
      title: 'Options d\'affichage du PDF',
      explain: 'Personnalisez l\'affichage des différentes informations qui apparaîtront sur votre document PDF.',
      contentTitle: 'Contenu du document',
      amounts: 'Affichage des montants dans le contenu du document',
      amountsChoice1: 'Utiliser les réglages de saisie du document',
      amountsChoice2: 'Afficher les montants HT',
      amountsChoice3: 'Afficher les montants TTC',
      amountsChoice4: 'Afficher les montants HT et le total TTC',
      discount: 'Affichage des remises',
      discountChoice1: 'Afficher une ligne négative avec la remise',
      discountChoice2: 'Ajouter une colonne remise et afficher le prix unitaire HT remisé',
      discountChoice3: 'Ajouter une colonne remise et afficher le prix unitaire HT non remisé',
      discountChoice4: 'Ajouter le prix unitaire HT remisé et non remisé',
      comments: 'Affichage des lignes de commentaires',
      commentsChoice1: 'Uniquement la largeur de la colonne description',
      commentsChoice2: 'Occuper toute la largeur du tableau',
      unit: 'Affichage des unités',
      unitExplain: 'Les unités ne seront affichées que si celle-ci sont activées lors de la saisie du document',
      unitChoice0: 'Ne pas afficher',
      unitChoice1: 'Afficher à droite de la quantité',
      unitChoice2: 'Afficher sous la quantité',
      unitChoice3: 'Afficher dans une colonne séparée',
      pictures: 'Affichage des photos',
      picturesExplain: 'Les photos ne seront affichées que si celle-ci sont activées lors de la saisie du document',
      picturesChoice1: 'Afficher les photos dans une colonne séparée',
      picturesChoice2: 'Afficher les photos sous la description',
      number: 'Affichage de la colonne numéro de ligne',
      reference: 'Affichage de la colonne référence',
      ean: 'Affichage du code EAN',
      weight: 'Affichage du poids unitaire',
      displayChoice1: 'Utiliser les réglages de saisie du document',
      displayChoice2: 'Afficher',
      displayChoice3: 'Ne pas afficher',
      vatrate: 'Forcer l\'affichage de la colonne TVA',
      vatrateExplain: 'La colonne TVA s\'affichera automatiquement si plusieurs taux de TVA sont présents.',
      vatrateChoice1: 'Affichage automatique',
      vatrateChoice2: 'Forcer l\'affichage',
      totalQuantity: 'Afficher la colonne quantité totale',
      totalQuantityExplain: 'Cette colonne ne peut être affichée que si la quantité secondaire est activée.',
      totalQuantityChoice1: 'Ne pas afficher',
      totalQuantityChoice2: 'Afficher la colonne quantité totale',
      addressesTitle: 'Adresses de livraison et de facturation',
      addressesChoice1: 'Afficher sur l\'adresse de facturation et de livraison',
      addressesChoice2: 'Masquer sur l\'adresse de facturation uniquement',
      addressesChoice3: 'Masquer sur l\'adresse de livraison uniquement',
      addressesChoice4: 'Masquer sur l\'adresse de facturation et de livraison',
      contact: 'Affichage du contact',
      country: 'Affichage du pays',
      vatrateNumber: 'Affichage du numéro de TVA intracommunautaire du client',
      vatrateNumberChoice1: 'Ne pas l\'afficher',
      vatrateNumberChoice2: 'L\'afficher uniquement pour les pays différents du vôtre',
      vatrateNumberChoice3: 'Toujours l\'afficher',
      situationColumns1: 'Ne pas afficher',
      situationColumns2: 'Afficher le total et le pourcentage dans la même colonne',
      situationColumns3: 'Afficher le total et le pourcentage dans des colonnes séparées',
      situationColumns4: 'Afficher uniquement le total',
      situationColumns5: 'Afficher uniquement le pourcentage'
    }
  },
  list: {
    date: 'Date',
    title: 'Titre',
    totalHt: 'Total HT',
    totalTva: 'Total TVA',
    totalTtc: 'Total TTC',
    status: 'Statut'
  },
  catalogSearch: {
    placeholder: 'Rechercher un produit, une prestation...',
    goToCatalog: 'Accéder au catalogue',
    noResults: 'Aucun résultat'
  },
  recoveryInvoice: {
    config: {
      pageTitle: 'Relances des factures impayées',
      menu: 'Relances des impayées',
      createTitle: 'Création d\'une étape de relance des factures',
      updateTitle: 'Modification d\'une étape de relance des factures',
      deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette étape de relance ?',
    }
  },
  months: {
    1: 'Janvier',
    2: 'Février',
    3: 'Mars',
    4: 'Avril',
    5: 'Mai',
    6: 'Juin',
    7: 'Juillet',
    8: 'Août',
    9: 'Septembre',
    10: 'Octobre',
    11: 'Novembre',
    12: 'Décembre'
  },
  signature: {
    status: {
      1: 'Brouillon',
      2: 'En attente d\'envoi',
      3: 'Envoyée',
      4: 'Signée partiellement',
      5: 'Signée',
      6: 'Annulée'
    },
    documentTypes: {
      quotation: 'Devis n°{reference}',
      command: 'Bon de commande n°{reference}',
      proforma: 'Facture proforma n°{reference}',
      delivery: 'Bon de livraison n°{reference}',
      customerSepa: 'Mandat SEPA n°{reference}',
      contract: 'Contrat n°{reference}'
    }
  }
}

const tasksLang = {
  searchTypes: {
    contract: 'Contrat'
  }
}

const calendarsLang = {
  searchTypes: {
    contract: 'Contrat'
  }
}

export default {
  sales: salesLang,
  tasks: tasksLang,
  calendars: calendarsLang
}
